import { useTranslation } from 'react-i18next';

import {
  spaces,
  Box,
  IconButton,
  Badge,
  useThemeColors,
  ColorsV2,
} from '@electricjs/arc';

type CartButtonProps = {
  itemsCount: number;
};

const CartButton = ({ itemsCount }: CartButtonProps) => {
  const { t } = useTranslation('storefront');

  const [badgeBackgroundColor] = useThemeColors([ColorsV2.SECONDARY]);

  return (
    <Box
      position="relative"
      pr={spaces.space_2xs_rem} // small padding-right to allow the badge to be fully seen
    >
      <IconButton
        id="go-to-cart-button"
        type="submit"
        disabled={!itemsCount}
        icon="cart-shopping"
        iconSize="medium"
        intent="primary"
        variant="fill"
        aria-label={t('steps.cart.goToCart')}
        alt={t('steps.cart.goToCart')}
      />
      <Badge
        size="1.8rem"
        variant="legal-bold"
        backgroundColor={badgeBackgroundColor}
        count={itemsCount}
        position="absolute"
        top="0px"
        left="2rem"
      />
    </Box>
  );
};

export default CartButton;
